import React from 'react'

function AddClass() {
  return (
    <div>AddClass</div>
  )
}

export default AddClass